module.exports = __webpack_public_path__ + "static/media/pending-approval-image.a51fa176.png";